module.exports = __webpack_public_path__ + "static/img/lyric-bg.30674dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/poem-recitation/lyric-bg.png
// module id = L0NY
// module chunks = 215